/**
 * Cross-cutting string constants shared by api/ and web/.
 * SCREAMING_SNAKE per engineering contract.
 */
import { ALL_TOOL_IDS } from './tool-ids.js';
/**
 * Postgres session variable that carries the current tenant for RLS.
 * The tenant-context middleware issues `SET LOCAL app.current_tenant = '<uuid>'`
 * per request; RLS policies read it via the `app.current_tenant_id()` helper.
 */
export const SESSION_TENANT_VAR = 'app.current_tenant';
// Tenancy v1 (2026-10-08): there is NO tenant claim on the bearer token any more.
// Tenants are WarehouseLogix rows; `/admin/t/:tenantId` is authorized from
// `app.tenant_member` (or the platform-admin allow-list). The Entra directory id
// (`tid`) is identity provenance only.
/** HTTP header carrying the bearer token (lower-case, as normalized by Node/Nest). */
export const AUTH_HEADER = 'authorization';
/** Scheme prefix (including trailing space) preceding a JWT in the auth header. */
export const BEARER_PREFIX = 'Bearer ';
/** Static SPA endpoint used by the version-check banner to detect new deploys. */
export const VERSION_ENDPOINT = '/version.json';
/**
 * HTTP header carrying the paired floor device token. Device+PIN auth, never
 * Entra: the floor PWA sends it on every call; the device auth guard reads it.
 * Must stay in the API's CORS allowed-headers list.
 */
export const DEVICE_TOKEN_HEADER = 'x-warehouselogix-device';
// ── Tool registry constants ──────────────────────────────────────────────────
/** Route prefix for the floor (device-authed) API surface. */
export const FLOOR_ROUTE_PREFIX = 'floor';
/** Reserved envelope action that probes an idempotency key (never a tool action). */
export const PROBE_ACTION = '_probe';
/** Human hub-tile labels for each tool (single canonical copy for both SPAs). */
export const TOOL_LABELS = Object.freeze({
    pick: 'Pick / Fulfill',
    xfer: 'Bin Transfer',
    adj: 'Adjust',
    pur: 'Purge',
    audit: 'Audit',
    find: 'Find',
});
/** Every tool id in hub display order (re-exported beside its labels). */
export const TOOL_REGISTRY_IDS = ALL_TOOL_IDS;
//# sourceMappingURL=constants.js.map